import React from "react";
import { Id, toast } from "react-toastify";
import { TOUCH_MIN_H } from "@/common/utils/touchTarget";

type Args = {
    message: string;
    actionLabel: string;
    onAction: () => void;
    toastId?: string;
    kind?: "success" | "warning";
};

/** EN-1196: first toast with an action button. 10 s, pauses on hover and focus loss. Returns the id for toast.dismiss. */
export function showActionToast({ message, actionLabel, onAction, toastId, kind = "success" }: Args): Id {
    return toast[kind](
        ({ closeToast }) => (
            <div className="flex items-center gap-3">
                <span className="flex-1 text-sm">{message}</span>
                <button
                    type="button"
                    className={`rounded-md border border-gray-300 bg-white px-2.5 py-1 text-sm font-semibold text-max-900 hover:bg-gray-50 ${TOUCH_MIN_H}`}
                    onClick={() => {
                        onAction();
                        closeToast?.();
                    }}
                >
                    {actionLabel}
                </button>
            </div>
        ),
        { autoClose: 10_000, pauseOnHover: true, pauseOnFocusLoss: true, closeOnClick: false, toastId },
    );
}
